import { apiFetch } from '../../lib/api';

export interface SceneItem {
  device_id: string;
  id: string;
  value: unknown;
}

export interface Scene {
  scene_id: string;
  name: string;
  enabled: boolean;
  items: SceneItem[];
  created_at: number;
  updated_at: number;
  last_run_at?: number;
  last_run_result?: string;
  last_correlation_id?: string;
}

export interface SceneApplyResult {
  scene_id: string;
  correlation_id?: string;
  actions: Array<{
    action_index: number;
    device_id: string;
    type: string;
    status: string;
    report?: Record<string, unknown>;
  }>;
}

export async function fetchScenes(limit = 30, signal?: AbortSignal): Promise<Scene[]> {
  const res = await apiFetch<Scene[]>('/v3/scenes', { query: { limit }, signal });
  return res.data ?? [];
}

export async function applyScene(sceneId: string, signal?: AbortSignal): Promise<SceneApplyResult> {
  const correlationId = globalThis.crypto?.randomUUID?.() ?? `scene-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const res = await apiFetch<SceneApplyResult>(`/v3/scenes/${encodeURIComponent(sceneId)}/apply`, {
    method: 'POST',
    body: { correlation_id: correlationId },
    signal,
  });
  return res.data;
}
